import { render, staticRenderFns } from "./flexbox.vue?vue&type=template&id=5297900b&"
import script from "./flexbox.vue?vue&type=script&lang=js&"
export * from "./flexbox.vue?vue&type=script&lang=js&"
import style0 from "./flexbox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports